import { Spinner } from "@jobber/components/Spinner";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { verifyLoginToken, ADMIN_SESSION_TOKEN_KEY } from "../../services";

const AuthCallback = () => {
    const { token } = useParams<{ token: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await verifyLoginToken(token);
                sessionStorage.setItem(ADMIN_SESSION_TOKEN_KEY, data.token);
                navigate("/dashboard", { replace: true });
            } catch (e: any) {
                navigate("/login", { replace: true });
            }
        })();
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <Spinner />
            <h1>Verifying login...</h1>
        </div>
    );
};

export default AuthCallback;
